import {
  STORE_MACHINE,
  STORE_GAME,
  STORE_ASSIGN_MACHINE,
  STORE_READING,
  STORE_ALL_READING,
  STORE_ALL_MATCH_TICKETS,
  STORE_CLOCK,
  STORE_ALL_EMPLOYEE_SESSION,
  STORE_UPDATED_EMPLOYEE_SESSION,
  STORE_ALL_SESSION_IDS,
  CLEAR_READING,
  STORE_MACHINE_PICTURE,
  START_LOADING,
  STOP_LOADING,
  STORE_CATEGORY,
  STORE_AVAILABLE_EMPLOYEE_SESSIONS,
  STORE_STARTED_SESSION,
  STORE_RESPONSE_MESSAGE,
  STORE_NOTES,
  STORE_REPORT,
  STORE_SHORT_ANALYSIS,
  CLEAR_WEEKLY_REPORT,
  STORE_COMPANIES,
  STORE_AVAILABLE_COMPANIES,
  SET_AVAILABLE_COMPANIES_STATUS,
  STORE_LICENSE,
  STORE_LICENSE_PAYMENTS,
  STORE_ACTIVE_LICENSES,
  STORE_ACTUAL_PROJECTIONS,
  STORE_YEARLY_PROJECTIONS,
  STORE_MANAGER_SETTING,
  STORE_MASTER_ADMINS_LOCATION,
  STORE_COMPANY_MEMBERSHIPS,
  STORE_MAINTENANCE_PERMIT,
  STORE_MAINTENANCE_PERMIT_HISTORY,
} from '../../constants/settings';
import {
  STORE_CLAIM_BONUS,
  STORE_MANAGE_BONUS,
  STORE_RULES,
  STORE_UPDATED_BONUS_IMAGE_WITH_PREVIEW,
} from '../../constants/ticketOut';
const initialState = {
  companies: [],
  availableCompanies: [],
  // 'idle' | 'loading' | 'failed'. The Select Company dialog reads this
  // so a failed fetch shows a retry instead of an empty list.
  availableCompaniesStatus: 'idle',
  companyMemberships: [],
  machines: [],
  games: [],
  assignTemplates: [],
  reading: '',
  readings: [],
  differenceList: [],
  employeeTickets: [],
  matchSession: {},
  clockRecord: null,
  employeeSession: [],
  manageBonus: [],
  claimBonus: [],
  bonusImage: null,
  bonus: [],
  rules: null,
  sessionIds: [],
  allMachinePictures: [],
  loadingData: false,
  categories: [],
  availableEmployeeSessions: [],
  loadStartedSession: null,
  responseMessage: '',
  notes: [],
  report: [],
  summary: [],
  employeeSummary: [],
  licenseKey: null,
  licensePayments: [],
  licensePaymentsTotal: 0,
  activeLicenses: [],
  actualProjections: [],
  yearlyProjections: [],
  managerSetting: null,
  managerSummary: null,
  summaryBreakdown: null,
  masterAdmins: [],
  maintenancePermit: null,
  maintenancePermitHistory: [],
};

const updateEmployeeSession = (oldEmployeeSession, updatedEmployeeSession) => {
  // Check if the invoice exists in the oldInvoices list based on poNumber and date
  let employeeSessionExists = oldEmployeeSession.find(
    (item) => item.clockId === updatedEmployeeSession.clockId
  );

  let newList;
  if (employeeSessionExists) {
    // Update the existing invoice
    newList = oldEmployeeSession.map((item) =>
      item.clockId === updatedEmployeeSession.clockId
        ? updatedEmployeeSession
        : item
    );
  } else {
    // Add the new invoice to the list
    newList = [...oldEmployeeSession, updatedEmployeeSession];
  }

  return {
    employeeSession: newList,
  };
};

const convertB64ToFileFormat = (image) => {
  if (image.length === 0) return null;
  let previewData = new Uint8Array(image);
  let blobData = new Blob([previewData]);
  let localStorageUrl = URL.createObjectURL(blobData);
  return {
    localURL: localStorageUrl,
    displayName: 'Image',
    byteArray: image,
    type: '',
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, loadingData: true };
    case STOP_LOADING:
      return { ...state, loadingData: false };
    case SET_AVAILABLE_COMPANIES_STATUS:
      return {
        ...state,
        availableCompaniesStatus: action.status,
      };
    case STORE_AVAILABLE_COMPANIES:
      return {
        ...state,
        availableCompaniesStatus: 'idle',
        availableCompanies: action.availableCompanies,
      };
    case STORE_ACTUAL_PROJECTIONS:
      return {
        ...state,
        actualProjections: action.data,
      };
    case STORE_YEARLY_PROJECTIONS:
      return {
        ...state,
        yearlyProjections: action.data,
      };
    case STORE_ACTIVE_LICENSES:
      return {
        ...state,
        activeLicenses: action.licenses,
      };
    case STORE_COMPANIES:
      return {
        ...state,
        companies: action.companies,
      };

    case STORE_MASTER_ADMINS_LOCATION:
      return {
        ...state,
        masterAdmins: action.data,
      };
    case STORE_LICENSE:
      return {
        ...state,
        licenseKey: action.licenseKey,
      };
    case STORE_LICENSE_PAYMENTS:
      return {
        ...state,
        licensePayments: action.payments,
        licensePaymentsTotal: action.totalCount || 0,
      };
    case STORE_COMPANY_MEMBERSHIPS:
      return {
        ...state,
        companyMemberships: action.memberships,
      };
    case STORE_MACHINE:
      return {
        ...state,
        machines: action.machine,
      };
    case STORE_ASSIGN_MACHINE:
      return {
        ...state,
        assignTemplates: action.assignTemplates,
      };
    case STORE_READING:
      return {
        ...state,
        reading: action.reading,
      };
    case STORE_AVAILABLE_EMPLOYEE_SESSIONS:
      return {
        ...state,
        availableEmployeeSessions: action.data,
      };
    case STORE_STARTED_SESSION:
      return {
        ...state,
        loadStartedSession: action.data,
      };
    case 'RESET_READING':
      return {
        ...state,
        reading: null,
      };
    case STORE_ALL_SESSION_IDS:
      return {
        ...state,
        sessionIds: action.data,
      };
    case STORE_ALL_READING:
      return {
        ...state,
        readings: action.readings,
      };
    case CLEAR_READING:
      return {
        ...state,
        readings: [],
      };
    case STORE_GAME:
      return {
        ...state,
        games: action.game,
      };
    case STORE_CATEGORY:
      return {
        ...state,
        categories: action.category,
      };
    case STORE_ALL_MATCH_TICKETS:
      return {
        ...state,
        differenceList: action.differenceList,
        employeeTickets: action.employeeTickets,
        matchSession: action.session || {},
      };
    case STORE_CLOCK:
      return {
        ...state,
        clockRecord: action.clockRecord,
      };
    case STORE_ALL_EMPLOYEE_SESSION:
      return {
        ...state,
        employeeSession: action.employeeSession,
      };
    case STORE_UPDATED_EMPLOYEE_SESSION:
      const updateResult = updateEmployeeSession(
        state.employeeSession,
        action.clockRecord
      );
      return {
        ...state,
        employeeSession: updateResult.employeeSession,
      };
    case STORE_MANAGE_BONUS:
      return {
        ...state,
        manageBonus: action.bonus,
      };
    case STORE_CLAIM_BONUS:
      return {
        ...state,
        claimBonus: action.bonus,
      };
    case STORE_UPDATED_BONUS_IMAGE_WITH_PREVIEW:
      return {
        ...state,
        bonusImage: convertB64ToFileFormat(action.previewedFile),
      };
    case STORE_RULES:
      return {
        ...state,
        rules: action.rules,
      };
    case STORE_MACHINE_PICTURE:
      return {
        ...state,
        allMachinePictures: action.allMachinePictures,
      };
    case STORE_RESPONSE_MESSAGE:
      return {
        ...state,
        responseMessage: action.responseMessage,
      };
    case STORE_NOTES:
      return {
        ...state,
        notes: action.notes,
      };
    case STORE_REPORT:
      return {
        ...state,
        report: action.weekReport,
        summary: action.summary,
        employeeSummary: action.employeeSummary,
        managerSummary: action.managerSummary,
        summaryBreakdown: action.summaryBreakdown,
      };

    case STORE_SHORT_ANALYSIS:
      return {
        ...state,
        shortAnalysis: action.shortAnalysis,
      };

    case STORE_MANAGER_SETTING:
      return {
        ...state,
        managerSetting: action.data,
      };
    case CLEAR_WEEKLY_REPORT:
      return {
        ...state,
        report: [],
        summary: [],
      };
    case STORE_MAINTENANCE_PERMIT:
      return {
        ...state,
        maintenancePermit: action.permit,
      };
    case STORE_MAINTENANCE_PERMIT_HISTORY:
      return {
        ...state,
        maintenancePermitHistory: action.history || [],
      };

    default:
      return state;
  }
};
